<template>
  <section class="font-open-sans" style="background-color:#f5f1ed">
    <div class="relative w-full px-5 py-12 mx-auto overflow-hidden lg:px-14 xl:px-20 2xl:px-12 xl:py-14 2xl:py-20">
      <div class="flex flex-wrap items-start lg:items-center">
        <div class="max-w-screen-xl mx-auto lg:max-w-screen-lg">
          <div class="float-left mr-6 p-1.5 textp w-5/12 sm:w-4/12 md:w-3/12 lg:w-2/12">
            <nuxt-img
                class=""
                width="294"
                height="306"
                loading="lazy"
                format="webp"
                :alt="imageAlt"
                :src="imageSrc"
                sizes="xs:106px sm:150px md:229px lg:231px xl:160px 2xl:294px"
            />
            <p class="pb-5 text-sm" v-html="imageName + ', <br>' + imageWork"></p>
          </div>
          <div class="inline w-5/12 md:float-left sm:w-7/12 md:w-8/12 lg:w-9/12">
            <h2 class="mb-4 text-2xl font-bold md:text-3xl xl:text-3xl font-ww-medium" v-html="textTitle"></h2>
            <div v-html="text1" class="mb-2"></div>
            <div v-html="text2" class="mb-2"></div>
            <ul class="grid py-6 list-disc list-inside">
              <li class="px-6 check" v-for="(benefit, index) in multipleBenefits" :key="index">
                <div class="inline pl-2" v-html="benefit.text"></div>
              </li>
            </ul>
            <div v-html="text3" class="mb-2"></div>
            <div v-html="text4" class="mb-2"></div>
            <div v-html="text5" class="mb-2"></div>
            <div v-html="text6" class="mb-2"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>

const props = defineProps({
  textTitle: {
    type: String,
    default: 'From the desk of Dr. Charles Livingston'
  },
  text1: {
    type: String,
    default: 'Johns Hopkins Medicine recently reported, “it’s safe for most people to drink three to five cups of coffee a day with a maximum intake of 400 milligrams of caffeine.1”'
  },
  text2: {
    type: String,
    default: 'They reported multiple benefits of drinking coffee...'
  },
  text3: {
    type: String,
    default: 'However, these benefits come with big risks in drinking coffee: pesticides, mycotoxins, and molds. One research study found that 91.7% of the coffee samples they tested contained molds.2'
  },
  text4: {
    type: String,
    default: 'To enjoy the full benefits without the downsides, we need a clean, healthy, non-GMO, pesticide-free, and pure-as-you-can-get coffee.'
  },
  text5: {
    type: String,
    default: 'Regular mass-produced, blended coffee is loaded with chemicals and additives that destroy the flavor. The best tasting coffee, it turns out, is also the healthiest coffee.'
  },
  text6: {
    type: String,
    default: 'After years of research and testing, I’m excited to share with you the cleanest, purest, healthiest coffee I’ve ever seen…It’s called Lifeboost Coffee.'
  },
  imageSrc: {
    type: String,
    default: '/dr_img.png'
  },
  imageAlt: {
    type: String,
    default: 'Dr. Charles Livingston'
  },
  imageName: {
    type: String,
    default: 'Dr. Charles Livingston'
  },
  imageWork: {
    type: String,
    default: 'Natural Health Expert'
  },
  multipleBenefits: {
    type: Array,
    default: () => [
      { text: 'A reduced likelihood to die from some of the leading causes of death,' },
      { text: 'Reduction of internal inflammation,' },
      { text: 'Protection against disease,' },
      { text: 'Stronger DNA, and more.' },
      // Add more benefits here...
    ]
  }
});

defineBuilderComponent({
    friendlyName: "FromDesk2",
    inputs: [
        {
            name: "textTitle",
            type: "richText",
            defaultValue: "From the desk of Dr. Charles Livingston"
        },
        {
            name: "text1",
            type: "richText",
            defaultValue: "Johns Hopkins Medicine recently reported, “it’s safe for most people to drink three to five cups of coffee a day with a maximum intake of 400 milligrams of caffeine.1”"
        },
        {
            name: "text2",
            type: "richText",
            defaultValue: "They reported multiple benefits of drinking coffee, including the following:"
        },
        {
            name: "text3",
            type: "richText",
            defaultValue: "However, these benefits come with big risks in drinking coffee: pesticides, mycotoxins, and molds. One research study found that 91.7% of the coffee samples they tested contained molds.2"
        },
        {
            name: "text4",
            type: "richText",
            defaultValue: "To enjoy the full benefits without the downsides, we need a clean, healthy, non-GMO, pesticide-free, and pure-as-you-can-get coffee."
        },
        {
            name: "text5",
            type: "richText",
            defaultValue: "Regular mass-produced, blended coffee is loaded with chemicals and additives that destroy the flavor. The best tasting coffee, it turns out, is also the healthiest coffee."
        },
        {
            name: "text6",
            type: "richText",
            defaultValue: "After years of research and testing, I’m excited to share with you the cleanest, purest, healthiest coffee I’ve ever seen…It’s called Lifeboost Coffee."
        },
        {
            name: "imageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "/dr_img.png"
        },
        {
            name: "imageAlt",
            type: "string",
            defaultValue: "Dr. Charles Livingston"
        },
        {
            name: "imageName",
            type: "string",
            defaultValue: "Dr. Charles Livingston"
        },
        {
            name: "imageWork",
            type: "string",
            defaultValue: "Natural Health Expert"
        },
        {
            name: "multipleBenefits",
            type: "list",
            subFields: [
                {
                    name: "text",
                    type: "richText"
                }
            ],
            defaultValue: [
                {
                    text: "A reduced likelihood to die from some of the leading causes of death,"
                },
                {
                    text: "Reduction of internal inflammation,"
                },
                {
                    text: "Protection against disease,"
                },
                {
                    text: "Stronger DNA, and more."
                }
            ]
        }
    ]
});
</script>

<style>
li.check {
  list-style-image: url('public/assets/images/chk.svg');
}
</style>